import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <Helmet>
        <title>Seite nicht gefunden (404) | FACHSPRECHPARTNER</title>
        <meta name="description" content="Diese Seite existiert nicht. Zurück zur Startseite von Fachsprechpartner – Beratung für OT-Security und Gebäudeautomation." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://fachsprechpartner.de/404" />
        <meta property="og:title" content="Seite nicht gefunden (404) | FACHSPRECHPARTNER" />
        <meta property="og:description" content="Diese Seite existiert nicht. Zurück zur Startseite von Fachsprechpartner." />
        <meta property="og:url" content="https://fachsprechpartner.de/404" />
      </Helmet>
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
